import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

// Renders a translation while invisibly reserving the width of the other
// language's version, so surrounding elements do not shift when the
// language is switched.
export default function LanguageStableText({ id, values }) {
  const { t, i18n } = useTranslation()
  const otherLanguage = i18n.language === 'en' ? 'da' : 'en'
  const tOther = i18n.getFixedT(otherLanguage)
  return (
    <span className="dib">
      <span
        aria-hidden="true"
        className="db nowrap"
        style={{ height: 0, overflow: 'hidden' }}
      >
        {tOther(id, values)}
      </span>
      <span className="db nowrap">{t(id, values)}</span>
    </span>
  )
}

LanguageStableText.propTypes = {
  id: PropTypes.string.isRequired,
  values: PropTypes.object,
}
